var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center pa-12",style:({
    width: '100%',
    height: '100vh',
    position: 'relative',
  })},[_c('hero-background',{staticStyle:{"position":"absolute","left":"0","top":"0"}}),_c('v-row',{staticStyle:{"height":"100%"}},[_c('v-col',{staticClass:"d-flex align-end",staticStyle:{"height":"100%"},attrs:{"cols":"10","md":"8","lg":"6"}},[_c('v-img',{attrs:{"src":_vm.ureideaLogo}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }